import { render } from "./Ganarc13.vue?vue&type=template&id=6bfc7116"
import script from "./Ganarc13.vue?vue&type=script&lang=js"
export * from "./Ganarc13.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__